import React from "react";
import { useLocation } from "react-router-dom";
import GenericCard from "@ui-components/Card/GenericCard";
import PaidLicenses from "../Licensing/PaidLicenses/PaidLicenses";
import PAYG from "../Licensing/PAYG/PAYG";
import LicenseModal from "../Licensing/LicenseModal/LicenseModal";

const LicensingPage: React.FC = () => {
  const location = useLocation();
  const [isLicenseModalOpen, setIsLicenseModalOpen] = React.useState(false);

  // Determine which component to render based on the current path
  const isPaidLicenses = location.pathname === "/reflector-v2/management/licensing" || location.pathname === "/reflector-v2/admin-center/management/licensing";
  //const isRegularLicensing = location.pathname === "/reflector-v2/management/licensing";

  return (
    <div className="relative">
      <GenericCard isCollapsible={false}>
        {/* Card Header: Title, Add Button */}
        {/* {isRegularLicensing && (
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-4 border-b border-gray-100">
            <div className="flex w-full justify-end">
              <GenericButton
                label="Add/Buy License"
                variant="brand"
                size="md"
                onClick={() => setIsLicenseModalOpen(true)}
              />
            </div>
          </div>
        )} */}
        {/* Card Body: Tab Content */}
        <div>
          {isPaidLicenses ? (
            <PaidLicenses />
          ) : (
            <PAYG />
          )}
        </div>
      </GenericCard>
      {/* License Modal */}
      <LicenseModal
        isOpen={isLicenseModalOpen}
        onClose={() => setIsLicenseModalOpen(false)}
      />
    </div>
  );
};

export default LicensingPage; 